import BG_MHLOGO from "@/assets/login/mh_logo.png";
import IC_AGREE from "@/assets/login/ic_agree.svg";
import IC_NO_AGREE from "@/assets/login/ic_no_agree.svg";
import IC_WECHAT from "@/assets/login/ic_wechat.svg";
import IC_SETTING from "@/assets/login/ic_setting.svg";
import IC_VISIBLE from "@/assets/login/ic_visible.svg";
import IC_INVISIBLE from "@/assets/login/ic_invisible.svg";
import IC_GRAPHIC_DEFAULT from "@/assets/login/ic_graphic_default.png";
import IC_VISITOR from "@/assets/login/ic_visitor.svg";
import { useState, useRef, useEffect, useMemo } from "react";
import { validatePhoneNumber } from "../../../../utils/common";
import {
  sendCaptchas,
  loginByMobile,
  getQrcode,
  getSessionId,
  loginByWxcode,
  wxBindMobile,
  createWxClientAuthUrl,
  loginByPassword,
  getGraphicCaptcha,
  getXySessionId,
  getUserInfoByMobile,
  getVisitorToken,
  ESendCaptchasType,
} from "../../services/api_user";
import { ErrorModel, XyAccountError } from "@common/utils/http/types";
import { useNavigate } from "react-router-dom";
import EasyLoading from "@/component/EasyLoading";
import { setMainSize } from "@/utils/window";
import { createPortal } from "react-dom";
import { RuningInLink } from "@/constants";
import useLoginStore from "@/store/login.store";
import { isMobile, isSupportWxLogin } from "@/utils/platform";
import userInfoStore, { getUser } from "@/store/user.store";
import { parseUrlSearch } from "@/utils/query";
import { message } from "antd";
import CommonLoading from "@/component/CommonLoading";
import IcRecordFinishLoading from "@/assets/images/ic_record_finish_loading.png";
import ChoseCompany from "./ChoseCompany";
import CompanyHelper from '@/bussiness/CompanyHelper';
import ServiceConfig from './ServiceConfig';
import useServiceConfigStore from '@/store/serviceConfig.store';
import SecretSetting from './SecretSetting';
import { IS_PRIVATE } from '@/config';
import { encryptWithSha256 } from "@/utils/crypto";
import { VISITOR_TOKEN_STORAGE_KEY } from "@/constants/user";

let countInterval: NodeJS.Timeout | number | undefined = undefined;

const isWindows = navigator.platform.indexOf("Win") !== -1;
if (isWindows) {
  console.log("win");
} else {
  console.log("no win");
}

export interface LoginProps {
  className?: string;
  onLoginSuccess?: () => void;
}

export default function Login(props: LoginProps) {
  const { className, onLoginSuccess } = props;

  const [choseCompany, setchoseCompany] = useState(false);
  const [isDisableAutoJumpHome, setIsDisableAutoJumpHome] = useState(false);

  const [showLading, setShowLading] = useState(false);
  const [isAgree, setIsAgree] = useState(false);
  const [showWechat, setShowWechat] = useState(false);
  const [qrcodeUrl, setQrcodeUrl] = useState("");
  const [mobileValid, setMobileValid] = useState(true);
  const [captchasSending, setSaptchasSending] = useState(false);
  const [captchas, setCaptchas] = useState("");
  const [showGraphicCode, setShowGraphicCode] = useState(false);
  const [graphicCodeErr, setGraphicCodeErr] = useState(false);
  const [graphicCode, setGraphicCode] = useState("");
  const [graphicCodeImg, setGraphicCodeImg] = useState("");
  const [countDown, setCountDown] = useState(60);
  const [isMobileBind, setMobileBind] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [sendCaptLoading, setSendCaptLoading] = useState(false);
  const { setIsVisitor } = useLoginStore();

  // 服务配置显示状态
  const [showServiceConfig, setShowServiceConfig] = useState(false);
  const [showSecretSetting, setShowSecretSetting] = useState(false);

  // 密码可视状态
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  // 初始化服务配置 store
  const { initializeConfig } = useServiceConfigStore();
  const { mobile, setMobile } = useLoginStore();

  const ref = useRef(null);
  const session = useRef("");

  const navigate = useNavigate();

  const params = useMemo(() => {
    return parseUrlSearch<{
      code?: string;
      state?: string;
      redirectUrl?: string;
      type?: string;
      mode?: string;
      disableAutoJumpHome?: string;
    }>(location.search);
  }, []);

  // 判断是否从collaboration页面跳转而来，并提取streamId
  const { isFromCollaboration, collaborationStreamId } = useMemo(() => {
    const { redirectUrl } = params;
    if (!redirectUrl) {
      return { isFromCollaboration: false, collaborationStreamId: '' };
    }

    // 检查redirectUrl是否包含collaboration路径
    const isFromCollab = redirectUrl.includes('/collaboration');
    let streamId = '';

    if (isFromCollab) {
      // 从redirectUrl中提取streamId参数
      try {
        const url = new URL(redirectUrl, window.location.origin);
        streamId = url.searchParams.get('streamId') || '';
      } catch (e) {
        console.warn('解析redirectUrl失败:', e);
      }
    }

    return {
      isFromCollaboration: isFromCollab,
      collaborationStreamId: streamId
    };
  }, [params]);

  const autoLogin = () => {
    const { code } = params;
    if (!code) {
      return;
    }
    wxCodeToLogin(code, true);
  };

  useEffect(() => {
    const { mode, disableAutoJumpHome } = params;
    const isChoseCompany = mode === "choseCompany";
    if (isChoseCompany) {
      setIsDisableAutoJumpHome(disableAutoJumpHome === "true");
      setchoseCompany(true);
    } else {
      autoLogin();
    }

    // 初始化服务配置
    initializeConfig();
    if (IS_PRIVATE) {
      console.log("getXySessionId");
      getXySessionId();
    }

    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, [initializeConfig]);

  function onMessage(e: MessageEvent) {
    if (e.origin === location.origin && e.data.type === "weixin-scan-login-success") {
      window.removeEventListener("message", onMessage);
      console.log("weixin-scan-login-success", e.data.data);
      setShowWechat(false);
      wxCodeToLogin(e.data.data.code);
    }
  }

  const startMobileWxLogin = async () => {
    if (!isAgree) {
      message.info("请先勾选下方用户协议");
      return;
    }
    const url = createWxClientAuthUrl(location.href);
    window.location.href = url;
  };

  const startWxLogin = async () => {
    if (!isAgree) {
      message.info("请先勾选下方用户协议");
      return;
    }
    window.addEventListener("message", onMessage);
    try {
      setShowLading(true);
      const url = await getQrcode();
      setShowLading(false);
      setQrcodeUrl(url);
      setShowWechat(true);
    } catch (e) {
      setShowLading(false);
      console.log("登录二维码获取失败", e);
      message.warning("登录二维码获取失败");
    }
  };

  const cancelWxLogin = () => {
    window.removeEventListener("message", onMessage);
    setShowWechat(false);
  };

  const wxCodeToLogin = async (wxCode: string, isMobile = false) => {
    setShowLading(true);
    const sessionId = await getSessionId();
    if (sessionId == null) {
      setShowLading(false);
      message.warning("微信登录获取会话ID失败");
      return;
    }
    session.current = sessionId;
    try {
      await loginByWxcode({ code: wxCode, sessionId, isMobile });
      setShowLading(false);
      handleSuccess();
    } catch (e) {
      setShowLading(false);
      console.log("Login by wxcode error >>>>", e);
      const err = e as ErrorModel;
      if (err.errCode === 40001109) {
        message.warning("请绑定手机号");
        setMobileBind(true);
      } else {
        message.warning(err.errMsg ?? "登录失败，请稍后重试");
      }
    }
  };

  const startVisitorLogin = async () => {
    console.log("startVisitorLogin");
    try {
      const data = await getVisitorToken() as { token: string };
      localStorage.setItem(VISITOR_TOKEN_STORAGE_KEY, data.token);
    } catch (e) {
      console.log("getVisitorToken error >>>>", e);
      message.warning("访客登录失败，请稍后重试");
      return;
    }
    setIsVisitor(true);

    const redirectUrl =
      params["redirectUrl"] ||
      `/collaboration?streamId=${collaborationStreamId}`;
    navigate(redirectUrl, { replace: true });
  };

  const onMobileInput = (content: string) => {
    const value = content.replace(/\D/gm, "");
    setMobile(value);
  };

  const checkMobileValid = () => {
    const isValid = validatePhoneNumber(mobile);
    setMobileValid(isValid);
  }

  const onMobileBlur = () => {
    checkMobileValid();
  };

  const sendHandle = async () => {
    if (captchasSending || sendCaptLoading) return;
    if (!mobile || !mobileValid) {
      return;
    }
    setSendCaptLoading(true);
    const data = await sendCaptchas(mobile, isMobileBind ? ESendCaptchasType.WeixinBind : ESendCaptchasType.Login);
    setSendCaptLoading(false);
    if (!data.success) {
      message.warning("验证码发送失败");
      if (data.data && !isNaN(Number(data.data))) {
        setCountDown(Number(data.data));
      } else {
        return;
      }
    }
    setSaptchasSending(true);
    countInterval = setInterval(() => {
      setCountDown((count) => {
        if (count === 1) {
          setSaptchasSending(false);
          clearInterval(countInterval);
          countInterval = undefined;
          return 60;
        } else {
          return count - 1;
        }
      });
    }, 1000);
  };

  const onCaptchasInput = (content: string) => {
    const value = content.replace(/\D/gm, "");
    setCaptchas(value);
  };

  const onPasswordInput = (content: string) => {
    setPassword(content);
  }

  const btnHandle = () => {
    if (!allowLogin || submitLoading) return;
    if (isMobileBind) {
      mobileBind();
    } else if (IS_PRIVATE) {
      passwordLogin();
    } else {
      mobileLogin();
    }
  };

  const collapseSecretSetting = () => {
    setShowSecretSetting(false);
    checkMobileValid();
  }

  async function mobileLogin() {
    if (isAgree) {
      try {
        setSubmitLoading(true);
        await loginByMobile(mobile, captchas);
        handleSuccess();
      } catch (e) {
        console.log("LoginByMobile error >>>>", e);
        message.warning((e as ErrorModel).errMsg ?? "登录失败，请稍后重试");
      } finally {
        setSubmitLoading(false);
      }
    } else {
      message.info("请先勾选下方用户协议");
    }
  }

  async function passwordLogin() {
    if (!isAgree) {
      message.info("请先勾选下方用户协议");
      return;
    }
    try {
      setSubmitLoading(true);
      const isBindCompany = await isUserBindCompany();
      if (!isBindCompany) {
        message.warning("该账户未绑定组织，请先联系管理员");
        return;
      }
      const encryptedPassword = encryptWithSha256(password);
      const params = {
        username: mobile,
        password: encryptedPassword,
        ...(graphicCode ? { graphicCaptcha: graphicCode } : {}),
      }
      await loginByPassword(params);
      handleSuccess();
    } catch (e) {
      console.log("LoginByPassword error >>>>", e);
      const errorCode = (e as ErrorModel).errCode;
      const text = errorCode === XyAccountError.graphicCaptchaInvalid ? "图形验证码错误，请重新输入" : "账号或密码错误，请重新输入";
      message.warning(text);
      if (errorCode === XyAccountError.graphicCaptchaRequired || showGraphicCode) {
        getGraphicCaptchaImg();
        setShowGraphicCode(true);
      }
    } finally {
      setSubmitLoading(false);
    }
  }

  async function isUserBindCompany() {
    try {
      // 如果用户信息中没有company，则认为用户未绑定组织，返回 false
      const userInfo = await getUserInfoByMobile(mobile);
      if (userInfo.company === null) {
        return false;
      }
      return true;
    } catch (e) {
      // 如果获取用户信息失败，那是由于没有注册，无法确定是否绑定组织，所以返回 true
      return true;
    }
  }

  async function getGraphicCaptchaImg() {
    try {
      const res = await getGraphicCaptcha();
      setGraphicCodeImg(res);
      if (!showGraphicCode) {
        setGraphicCodeErr(true);
      }
    } catch (e) {
      message.warning("获取图形验证码失败，请稍后重试");
      setGraphicCodeImg(IC_GRAPHIC_DEFAULT);
    }
  }

  // 处理图形验证码输入
  const handleGraphicCodeInput = (inputValue: string) => {
    // 限制只能输入4位字符
    const value = inputValue.slice(0, 4);
    setGraphicCode(value);
    setGraphicCodeErr(value.length === 0);
  };

  async function handleSuccess() {
    clearInterval(countInterval);
    countInterval = undefined;
    useLoginStore.getState().setHasLogin(true);
    const redirectUrl = params["redirectUrl"];
    await getUser(true);
    if (redirectUrl) {
      navigate(redirectUrl, { replace: true });
      return;
    }
    // 处理成功后的逻辑
    if (onLoginSuccess) {
      onLoginSuccess();
    } else {
      defaultLoginSuccess();
    }
  }

  const defaultLoginSuccess = async () => {
    const alreadySwitched = userInfoStore.getState().switchOrg;
    const isonlyPersonal = await CompanyHelper.onlyPersonal();
    if (isonlyPersonal) {
      setMainSize();
      navigate("/home", { replace: true });
    } else {
      if (alreadySwitched) {
        setMainSize();
        navigate("/home", { replace: true });
        return;
      }

      // 如果只有一个企业，则直接进入企业
      const { isOnlyOneCompany, companyId } = await CompanyHelper.onlyOneCompany();
      if (isOnlyOneCompany && companyId) {
        CompanyHelper.choiceCompany(companyId, () => {
          setMainSize();
          navigate("/home", { replace: true });
        });
      }
      else {
        // 存在企业 & 没有设置过，则进入选择企业
        setchoseCompany(true);
      }
    }
  }

  async function mobileBind() {
    try {
      setSubmitLoading(true);
      await wxBindMobile({ mobile, captcha: captchas, sessionId: session.current });
      handleSuccess();
    } catch (e) {
      console.log("Mobile bind error >>>>", e);
      message.warning((e as ErrorModel).errMsg ?? "手机绑定失败，请稍后重试");
    } finally {
      setSubmitLoading(false);
    }
  }

  // 服务配置相关处理函数
  const openServiceConfig = () => {
    setShowServiceConfig(true);
  };

  const closeServiceConfig = () => {
    setShowServiceConfig(false);
  };

  const handleServiceConfigConfirm = () => {
    console.log("服务配置已确认");
  };

  const allowLogin = useMemo(() => {
    if (IS_PRIVATE) {
      return mobileValid && password.length > 0 && (graphicCodeErr ? graphicCode.length > 0 : true);
    } else {
      return mobileValid && captchas.length == 6;
    }
  }, [mobileValid, password, captchas, graphicCodeErr, graphicCode]);

  // 登录表单
  const loginForm = () => {
    return (
      <div className="w-80 flex flex-col text-size-4 text-mx-secondary">
        <div className="h-12 bg-#F4F6F9 rd-2.5 py-2 px-3">
          <input
            className="w-full h-8 border-0 bg-transparent text-size-4 focus:outline-none placeholder:text-#A1A7B2 placeholder:text-size-4"
            placeholder="手机号"
            maxLength={11}
            value={mobile}
            onChange={(e) => {
              onMobileInput(e.target.value);
            }}
            onBlur={onMobileBlur}
          ></input>
        </div>
        <div className="h-6 text-size-3 text-#FF584C ml-4 pt-0.5">
          {!mobileValid && mobile ? "手机号码格式不正确" : ""}
        </div>
        {IS_PRIVATE && (
          <>
            <div>
              <div className="h-12 bg-#F4F6F9 rd-2.5 py-2 px-3 flex flex-items-center">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => onPasswordInput(e.target.value)}
                  className="flex-1 h-8 border-0 bg-transparent text-size-4 focus:outline-none placeholder:text-#A1A7B2 placeholder:text-size-4"
                  placeholder="密码"
                />
                <button
                  type="button"
                  className="ml-2 w-6 h-6 flex flex-items-center flex-justify-center cursor-pointer border-0 bg-transparent"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <img src={IC_VISIBLE} alt="visible" />
                  ) : (
                    <img src={IC_INVISIBLE} alt="invisible" />
                  )}
                </button>
              </div>
              <div className="h-6 text-size-3 text-#FF584C ml-4 pt-0.5"></div>
            </div>
            {showGraphicCode && (
              <div>
                <div className="flex flex-items-center">
                  <div className="h-12 bg-#F4F6F9 rd-2.5 py-2 px-3 flex flex-items-center">
                    <input
                      onChange={(e) => handleGraphicCodeInput(e.target.value)}
                      maxLength={4}
                      className="flex-1 h-8 border-0 bg-transparent text-size-4 focus:outline-none placeholder:text-#A1A7B2 placeholder:text-size-4"
                      placeholder="请输入图形验证码"
                      value={graphicCode}
                    />
                  </div>
                  <div
                    className="w-26.5 h-12 ml-4 bg-#F4F6F9 rd-2.5 flex flex-items-center flex-justify-center cursor-pointer"
                    onClick={getGraphicCaptchaImg}
                  >
                    <img
                      src={graphicCodeImg ? graphicCodeImg : IC_GRAPHIC_DEFAULT}
                      alt="graphic"
                      className={`w-26.5 h-12 rd-2.5 ${graphicCodeImg ? "border-1 border-solid border-#0000001A" : ""
                        }`}
                    />
                  </div>
                </div>
                <div className="h-6 text-size-3 text-#FF584C ml-4 pt-0.5">
                  {graphicCodeErr ? "请输入图形验证码" : ""}
                </div>
              </div>
            )}
          </>
        )}
        {!IS_PRIVATE && (
          <div className="flex flex-justify-between bg-#F4F6F9 rd-2.5 mb-6">
            <div className="flex-1 h-12 py-2 px-3">
              <input
                className="w-full h-8 border-0 bg-transparent text-size-4 focus:outline-none placeholder:text-#A1A7B2 placeholder:text-size-4"
                placeholder="6位短信验证码"
                maxLength={6}
                onChange={(e) => {
                  onCaptchasInput(e.target.value);
                }}
              ></input>
            </div>
            <div
              className={`px-3 h-12 ${captchasSending || sendCaptLoading
                ? "text-#A1A7B2"
                : "text-#4981F2 cursor-pointer"
                } text-size-3.2 ml-2 lh-12`}
              onClick={sendHandle}
            >
              {captchasSending ? `${countDown}S后重试` : "获取短信验证码"}
            </div>
          </div>
        )}
        <button
          className={`cursor-pointer mt-2 w-full h-12 bg-#293143 rd-2.5 flex flex-items-center flex-justify-center text-size-3.2
         ${allowLogin ? "text-#FFFFFF" : "text-#FFFFFF4D"} ${allowLogin ? "hover:bg-#293143E6" : ""
            }  outline-none border-none`}
          onClick={btnHandle}
        >
          {submitLoading ? (
            <CommonLoading src={IcRecordFinishLoading} className={`size-4`} />
          ) : isMobileBind ? (
            "绑定"
          ) : IS_PRIVATE ? (
            "登录"
          ) : (
            "注册/登录"
          )}
        </button>
      </div>
    );
  };

  const mobileBindForm = () => {
    return createPortal(
      <div className={`absolute w-full h-full`}>
        <div className={`bg-#1F2533B2 flex flex-items-center flex-justify-center w-full h-full`}>
          <div className="bg-white w-75.5 h-85 flex flex-col flex flex-items-center flex-justify-center">
            <span>请使用微信扫码</span>
            <iframe ref={ref} className="mt-5 mb-4.5 w-42.5 h-42.5 b-none" src={qrcodeUrl} sandbox="allow-scripts allow-same-origin"></iframe>
            <div className="w-25 h-9 rd-1 bg-#e5e5e5 text-align-center lh-9 text-size-4 text-#1F2533 cursor-pointer" onClick={cancelWxLogin}>
              取消
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  };

  if (choseCompany) {
    return <ChoseCompany disableAutoJumpHome={isDisableAutoJumpHome} />;
  }

  // 如果正在显示服务配置，返回服务配置页面
  if (showServiceConfig) {
    return <ServiceConfig
      onCancel={closeServiceConfig}
      onConfirm={handleServiceConfigConfirm}
    />;
  }

  if (showSecretSetting) {
    return <SecretSetting
      onCancel={collapseSecretSetting}
      onConfirm={collapseSecretSetting}
    />;
  }

  const handleOpenAgreeMent = (
    e: React.MouseEvent<HTMLSpanElement>,
    type: string
  ) => {
    e.stopPropagation();
    let url = '';
    if (type === 'privacy') {
      url = "https://account.seewo.com/seewo-account/agreement?appCode=MaxLink-AI-Client&type=0&index=0";
    }
    else if (type === 'user') {
      url = "https://account.seewo.com/seewo-account/agreement?appCode=MaxLink-AI-Client&type=1&index=1";
    }
    window.open(url);
  }

  return (
    <div className={`login ${className ?? ""} h-full bg-white flex flex-col flex-items-center px-9 relative left-1/2 top-1/2 -translate-1/2`}>
      <EasyLoading isShow={showLading}></EasyLoading>
      {RuningInLink && (
        <div
          className="fixed left-2 bottom-2 z-10 flex flex-items-center flex-justify-center cursor-pointer"
          onClick={openServiceConfig}
        >
          <img className="w-7 h-7" src={IC_SETTING} alt="设置" />
        </div>
      )}
      <img className={`login-logo w-49.73 h-7.24 ${RuningInLink ? (isWindows ? "mt-16" : "mt-13") : "mt-30"} mb-5.25 select-none`} draggable={false} src={BG_MHLOGO}></img>
      <span className="text-#999999 text-size-3.5 mb-12 select-none">AI会议记录</span>
      {loginForm()}
      {!isMobileBind && (
        <div
          className="flex mt-4 flex-items-center cursor-pointer"
          onClick={() => {
            setIsAgree(!isAgree);
          }}
        >
          <img className="w-3.5 h-3.5 mr-1.5" draggable={false} src={isAgree ? IC_AGREE : IC_NO_AGREE}></img>
          <span className="text-#999999 text-size-3.5">
            已阅读并同意<span className="text-mx-secondary" onClick={(e) => { handleOpenAgreeMent(e, 'privacy') }}>《隐私政策》</span>和<span className="text-mx-secondary" onClick={(e) => { handleOpenAgreeMent(e, 'user') }}>《用户协议》</span>
          </span>
        </div>
      )}
      {IS_PRIVATE && (
        <div className="text-#4981F2 text-size-3.5 mt-8 cursor-pointer">
          <span onClick={() => setShowSecretSetting(true)}>新用户登录</span>
        </div>
      )}
      <div className="flex flex-justify-between rd-2.5 gap-10">
        {!isMobileBind && isSupportWxLogin() && !IS_PRIVATE && (
          <div className="flex flex-col flex-items-center">
            <img
              className="w-12 h-12 mt-18 mb-2 cursor-pointer"
              src={IC_WECHAT}
              onClick={() => {
                isMobile() ? startMobileWxLogin() : startWxLogin();
              }}
            ></img>
            <div className="text-#A1A7B2 text-size-3">微信登录</div>
          </div>
        )}
        {!isMobileBind && isFromCollaboration && (
          <div className="flex flex-col flex-items-center">
            <img
              className="w-12 h-12 mt-18 mb-2 cursor-pointer"
              src={IC_VISITOR}
              onClick={() => {
                startVisitorLogin();
              }}
            ></img>
            <div className="text-#A1A7B2 text-size-3">访客浏览</div>
          </div>
        )}
      </div>
      {showWechat && mobileBindForm()}
    </div>
  );
}
